import createReactClass from 'create-react-class';
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import * as Symbols from '@wix/santa-editor-symbols';
import { translate } from '#packages/i18n';

import { AutoComplete, Input, listItemSelectBuilder } from '@wix/design-system';

import * as core from '#packages/core';
import * as util from '#packages/util';
import * as coreBi from '#packages/coreBi';
import constants from '#packages/constants';
import * as BaseUI from '#packages/baseUI';
import { Button } from '@wix/wix-base-ui';
import { cx } from '#packages/util';
import type { TpaInnerRouteData } from '#packages/stateManagement';
import type { SitemapEntry } from 'types/documentServices';
import type { FullDynamicPagesComboBoxProps } from './dynamicPagesComboBox';

const isNewWorkspace = util.workspace.isNewWorkspaceEnabled();

export const autoCompleteDataHook = 'dynamic-pages-combo-auto-complete';

const EXCLUDED_CLASSNAMES_FROM_DRAG = [
  'button-content',
  'tooltip-on-ellipsis-content',
  'combo-box-wrapper',
  'c1',
  'selected-content',
  'symbol-close',
  'close-area',
  'selected-container',
  'symbol-arrow-down',
];

const MAX_HEIGHT_PIXELS_DROPDOWN = '335';

type InnerRoute = SitemapEntry | TpaInnerRouteData;

function startsWithCaseInsensitive(a = '', b = '') {
  if (a === undefined) {
    return;
  }
  return !b || a.toLowerCase().startsWith(b.toLowerCase());
}

const DynamicPageComboBoxLogic =
  // eslint-disable-next-line react/prefer-es6-class
  createReactClass<FullDynamicPagesComboBoxProps>({
    displayName: 'dynamicPagesComboBox',
    render() {
      const { shouldShowMainAction, dynamicPageNavBarConfig } = this.state;
      return this.shouldShowInnerRoutesDropDown()
        ? (() => {
            return (
              <div
                key="dynamicPageComboBox"
                className={cx(
                  'dynamic-pages-combo-box',
                  shouldShowMainAction
                    ? 'show-manage-button'
                    : 'no-show-manage-button',
                  this.props.shouldOverrideInitPosition &&
                    'override-initial-position',
                )}
                onMouseDown={(e) => {
                  const { classList } = e.target as HTMLDivElement;
                  if (
                    !EXCLUDED_CLASSNAMES_FROM_DRAG.some(
                      (className) =>
                        classList.contains(className) || classList.length === 0,
                    )
                  ) {
                    this.startDrag(e, this.getDragLimits());
                  }
                }}
                onMouseUp={() => {
                  this.endDrag();
                }}
              >
                <div className="dragable-area">
                  {isNewWorkspace ? (
                    <Symbols.symbol name="dragHandler" />
                  ) : (
                    <BaseUI.symbol
                      name="smalldragHandle"
                      className="symbol-smallDragHandle"
                    />
                  )}
                </div>
                <div className={cx('combo-box-wrapper')}>
                  <AutoComplete
                    dataHook={autoCompleteDataHook}
                    value={
                      this.state.userTyping ?? this.state.currentProductName
                    }
                    size="small"
                    maxHeightPixels={MAX_HEIGHT_PIXELS_DROPDOWN}
                    textOverflow="ellipsis"
                    suffix={
                      <Input.Affix>
                        {dynamicPageNavBarConfig?.numberAndLabel ??
                          translate(
                            this.props.innerRoutes.length === 1
                              ? 'Platform_Sausage_OOI_Number_of_Items_One'
                              : 'Platform_Sausage_OOI_Number_of_Items',
                            {
                              Num_Items: this.props.innerRoutes.length,
                            },
                          )}
                      </Input.Affix>
                    }
                    key="innerRouteDropDown"
                    onSelect={(e) => {
                      this.props.sendBI(
                        coreBi.events.dynamicPageComboBox.item_selected,
                        e.id,
                      );
                      if (e.id === this.props.selectedInnerRoute) {
                        this.setState({ userTyping: undefined });
                      } else {
                        this.props.setSelectedInnerRoute(
                          e.id,
                          this.props.routerId,
                        );
                      }
                    }}
                    onBlur={() => {
                      if (this.state.userTyping !== undefined) {
                        // Use a timeout to avoid flickering caused by rapid updates when switching inner routes
                        setTimeout(() => {
                          this.setState({ userTyping: undefined });
                        }, 0);
                      }
                    }}
                    onInputClicked={() => {
                      this.props.sendBI(
                        coreBi.events.dynamicPageComboBox.click,
                        this.state.selectedRouteValue,
                      );
                    }}
                    className="dynamic-pages-combobox"
                    options={this.state.routesOptions}
                    selectedId={this.state.selectedRouteValue}
                    onChange={(obj) => {
                      this.setState({ userTyping: obj.target.value });
                    }}
                    predicate={(option) =>
                      startsWithCaseInsensitive(
                        option.label?.trim(),
                        this.state.userTyping?.trim(),
                      )
                    }
                  />
                </div>
                {shouldShowMainAction && (
                  <Button
                    dataHook="buttonDataHook"
                    key="manageButton"
                    onClick={() => {
                      this.props.notifyApplication(
                        dynamicPageNavBarConfig?.navBarMainAction?.actionId,
                      );
                      this.props.sendBI(
                        coreBi.events.dynamicPageComboBox.manage_clicked,
                        this.props.selectedInnerRoute,
                        dynamicPageNavBarConfig?.navBarMainAction?.label,
                      );
                    }}
                    className={cx('go-to-manage', 'btn-text', 'manage')}
                    shouldTranslate={false}
                  >
                    {dynamicPageNavBarConfig?.navBarMainAction?.label}
                  </Button>
                )}
              </div>
            );
          })()
        : null;
    },
    mixins: [core.mixins.editorAPIMixin, util.draggableMixin],
    getInitialState() {
      return {
        shouldShowNavigation: true,
        rangeStartIndex: 0,
        userTyping: undefined,
      };
    },
    propTypes: {
      previewMode: PropTypes.bool.isRequired,
      editorIsInit: PropTypes.bool.isRequired,
      devModeContext: PropTypes.object.isRequired,
      stageLayout: PropTypes.object,
      innerRoutes: PropTypes.array.isRequired,
      selectedInnerRoute: PropTypes.string,
      routerId: PropTypes.string,
      setSelectedInnerRoute: PropTypes.func.isRequired,
      getDynamicPageNavBarConfig: PropTypes.func.isRequired,
      sendBI: PropTypes.func.isRequired,
      notifyApplication: PropTypes.func.isRequired,
      style: PropTypes.object,
    },
    componentDidMount() {
      this.setState({
        routesOptions: this.getInnerRoutesDropDownOptions(
          this.props.innerRoutes,
        ),
      });
    },
    async componentDidUpdate(prevProps) {
      if (
        !this.props.editorIsInit ||
        !this.props.selectedInnerRoute ||
        _.isEmpty(this.props.innerRoutes)
      ) {
        return;
      }

      if (
        this.props.routerId !== prevProps.routerId ||
        !_.isEqual(prevProps.tpaInfo, this.props.tpaInfo) ||
        !_.isEqual(prevProps.innerRoutes, this.props.innerRoutes)
      ) {
        const dynamicPageNavBarConfig =
          await this.props.getDynamicPageNavBarConfig(
            this.props.innerRoutes.length,
          );
        this.setState({
          shouldShowNavigation: true,
          dynamicPageNavBarConfig,
          shouldShowMainAction: !!dynamicPageNavBarConfig?.navBarMainAction,
        });
      }

      if (
        this.props.routerId !== prevProps.routerId ||
        !_.isEqual(prevProps.innerRoutes, this.props.innerRoutes)
      ) {
        this.props.sendBI(
          coreBi.events.dynamicPageComboBox.show,
          this.props.selectedInnerRoute,
        );
      }

      const index = this.findInnerRouteIndex(
        this.props.selectedInnerRoute,
        this.props.innerRoutes,
      );
      const selectedRouteValue = this.getInnerRouteUrl(
        this.props.innerRoutes[index],
      );

      const currentProductName = this.getCurrentProductName(selectedRouteValue);

      const hasSelectedRouteChanged =
        this.props.selectedInnerRoute !== prevProps.selectedInnerRoute;
      const hasCurrentProductNameChanged =
        currentProductName !== this.state.currentProductName;

      if (hasSelectedRouteChanged || hasCurrentProductNameChanged) {
        this.setState({
          selectedRouteValue,
          currentProductName,
          userTyping: undefined,
          clearUserTyping: false,
        });
      }

      if (prevProps.innerRoutes !== this.props.innerRoutes) {
        this.setState({
          routesOptions: this.getInnerRoutesDropDownOptions(
            this.props.innerRoutes,
          ),
        });
      }
    },
    shouldComponentUpdate(nextProps, nextState) {
      return (
        !_.isEqual(this.state, nextState) || !_.isEqual(this.props, nextProps)
      );
    },
    getCurrentProductName(selectedRouteValue: string) {
      const matchedItem = this.props.innerRoutes?.find(
        (item: any) => (item.path ?? item.url) === selectedRouteValue,
      );
      return (matchedItem as any)?.title ?? (matchedItem as any)?.name;
    },
    isSelectedInnerRouteValid() {
      return (
        this.props.selectedInnerRoute !== null &&
        this.props.selectedInnerRoute !== undefined &&
        this.props.selectedInnerRoute !== ''
      );
    },
    shouldShowInnerRoutesDropDown() {
      const editorAPI = this.getEditorAPI();
      const developerContext = editorAPI.dsRead?.pages.getFocusedPageId
        ? editorAPI.developerMode.getContext()
        : {};
      const isPageContext =
        developerContext.type === constants.DEVELOPER_MODE.CONTEXT_TYPES.PAGE;
      const isShowingFixedComponentsEnabled = editorAPI.dsRead?.documentMode
        ? editorAPI.dsRead.documentMode.isShowingFixedComponentsEnabled()
        : true;
      const isThePageFocused = editorAPI.dsRead?.pages.getFocusedPageId
        ? editorAPI.dsRead.pages.getFocusedPageId() ===
          editorAPI.dsRead.pages.getPrimaryPageId()
        : true;
      return (
        isThePageFocused &&
        this.state.shouldShowNavigation &&
        (this.props.routerId || this.props.tpaInfo) &&
        !_.isEmpty(this.props.innerRoutes) &&
        (this.props.previewMode || isPageContext) &&
        isShowingFixedComponentsEnabled &&
        this.isSelectedInnerRouteValid()
      );
    },
    getInnerRouteUrl(innerRoute: InnerRoute) {
      if (this.props.routerId) {
        return (innerRoute as SitemapEntry).url;
      }
      return (innerRoute as TpaInnerRouteData).path;
    },
    getInnerRoutesDropDownOptions(innerRoutes: InnerRoute[]) {
      return innerRoutes.map((innerRoute) => {
        const innerRouteUrl = this.getInnerRouteUrl(innerRoute);
        const innerRouteName =
          (innerRoute as SitemapEntry).title ??
          (innerRoute as TpaInnerRouteData).name;

        return listItemSelectBuilder({
          id: innerRouteUrl,
          label: innerRouteName,
          title: innerRouteName,
          size: 'small',
          ellipsis: true,
        });
      });
    },
    openHelpCenter() {
      const editorAPI = this.getEditorAPI();
      const helpId = 'b853c294-8ff1-418f-b4d2-29d7b59a85c3'; // TODO: change helpid
      const biHelpParams = {
        origin: 'display-combo-box',
        panel_name: 'dynamic-pages-display-combo-box',
        component: this.props.id,
      };

      editorAPI.panelManager.openHelpCenter(helpId, null, biHelpParams);
    },
    findInnerRouteIndex(innerRoute: string, innerRoutes: InnerRoute[]) {
      let index = innerRoutes.findIndex(
        (route) => this.getInnerRouteUrl(route) === innerRoute,
      );
      if (index === -1) {
        const decoded = decodeURIComponent(innerRoute);
        index = innerRoutes.findIndex(
          (route) => this.getInnerRouteUrl(route) === decoded,
        );
      }
      return index === -1 ? 0 : index;
    },
    moveToItem(index: AnyFixMe) {
      const newRoute =
        !_.isEmpty(this.props.innerRoutes) &&
        index < this.props.innerRoutes.length
          ? this.getInnerRouteUrl(this.props.innerRoutes[index])
          : null;
      this.props.setSelectedInnerRoute(newRoute, this.props.routerId);
    },
    getDragLimits() {
      let { stageLayout } = this.props;

      if (!stageLayout || this.props.isPreview) {
        stageLayout = window.document.body.getBoundingClientRect();
      }

      if (util.fixedStage.isFixedStageEnabled()) {
        return {
          x: [stageLayout.x, stageLayout.right],
          y: [
            stageLayout.top - constants.UI.FIXED_STAGE_MARGIN_TOP,
            stageLayout.bottom,
          ],
        };
      }

      return {
        x: [stageLayout.left, stageLayout.right],
        y: [stageLayout.top, stageLayout.bottom],
      };
    },
    onDragStart() {
      this.props.onDragStart?.();
    },
    onDragEnd() {
      this.props.onDragEnd?.();
    },
  });

export default DynamicPageComboBoxLogic;
